import angular from 'angular';
import '../../services/reception';
import '../../services/appointment';
import '../../services/identification';
import '../../services/errors';
import '../../services/queue';
import '../../services/access-control';
import { get, toUpper } from 'lodash';
import IdentificationType from '../../enums/identificationType';
import { CalledFromEnum } from '../../utils/calledFromEnum';
import { validatePersonId } from '../../utils';
import { localStorage } from '../../utils';
import { CallingAutomaticallyStatus, CallingAutomaticallyReason } from '../../enums/callingAutomatically';

const module = angular.module('whyline.controllers.reception-external-search', [
  'whyline.services.reception',
  'whyline.services.appointment',
  'whyline.services.identification',
  'whyline.services.queue',
  'whyline.services.errors',
  'whyline.services.notifications',
  'whyline.services.access-control',
]);

const ReceptionExternalSearchController = (
  $scope,
  $state,
  PlaceService,
  SAFE_STATES,
  AppointmentService,
  IdentificationService,
  GlobalsService,
  QueueService,
  ErrorService,
  NotificationService,
  $translate,
  AccessControlService,
  ValidationService,
  $window
) => {
  /* @ngInject */

  if (!$state.params.idNumber && !$state.params.externalPlaceId) {
    NotificationService.Error($translate.instant('mandatory_qs_{parameter}').replace('{parameter}', 'idNumber, externalPlaceId'));
    return;
  }

  if (!$state.params.idNumber) {
    NotificationService.Error($translate.instant('mandatory_qs_{parameter}').replace('{parameter}', 'idNumber'));
    return;
  }
  
  if (!$state.params.externalPlaceId) {
    NotificationService.Error($translate.instant('mandatory_qs_{parameter}').replace('{parameter}', 'externalPlaceId'));
    return;
  }

  if ($state.params.idNumber.length < 6 || $state.params.idNumber.length > 11) {
    NotificationService.Error($translate.instant('min_length_qs_id_number'));
    return;
  }

  if (!/^\d+$/.test($state.params.idNumber)) {
    NotificationService.Error($translate.instant('invalid_id_number'));
    return;
  }

  let user = localStorage.get('user');
  const userId = get(user, '_id', '');

  if (get(user, 'callingAutomatically.status', CallingAutomaticallyStatus.Paused) === CallingAutomaticallyStatus.Active) {
    const serviceType = get(user, 'callingAutomatically.serviceType', '') || '';
    const serviceId = get(user, 'callingAutomatically.serviceId', '') || '';

    if (serviceType && serviceId) {
      const queueQuery = {[`${serviceType}Id`]: serviceId};

      QueueService.GetByIdAndType(serviceId, serviceType).then((queue) => {
        const placeId = get(queue, 'placeId', '') || '';

        if (placeId) {
          if (AccessControlService.isDisabledForPlace(placeId)) {
            NotificationService.Error($translate.instant('do_not_have_permission_for_this_section'));
            return;
          }
          PlaceService.GetOneAsPromise(placeId).then((place) => {
            const organizationId = get(place, 'organizationId', '') || '';

            if (organizationId) {
              NotificationService.Success($translate.instant('redirecting to the service with automatic call activated'));

              const nowServingQueueParams = Object.assign({}, queueQuery, { placeId, organizationId });
              return $state.go(SAFE_STATES.nowServingQueue, nowServingQueueParams);
            } else {
              $scope.pauseUserCallingAutomatically();
            }
          }).catch(ErrorService.handler);
        } else {
          $scope.pauseUserCallingAutomatically();
        }
      }).catch(ErrorService.handler);
    } else {
      $scope.pauseUserCallingAutomatically();
    }
  } else {
    PlaceService.FindByBranchId($state.params.externalPlaceId, $state.params.organizationId).then(place => {
      if (AccessControlService.isDisabledForPlace(place._id)) {
        NotificationService.Error($translate.instant('do_not_have_permission_for_this_section'));
        return;
      }
      GlobalsService.SetCurrentPlace(place);
      GlobalsService.SetCurrentOrganization({
        _id: place.organizationId
      });
      const idType = $state.params.idNumber.length >= 6 && $state.params.idNumber.length <= 8 ? IdentificationType.DNI : IdentificationType.CUIT;
      $scope.person = {
        id: $state.params.idNumber,
        idType,
        phone: {
          countryCode: toUpper(place.location.countryCode),
          full: '',
        },
        email: '',
        priority: {
          category: null,
        },
        gender: $state.params.gender && $state.params.idNumber.length <= 8 ? $state.params.gender : '',
      };
  
      if(idType === IdentificationType.CUIT && !$scope.validatePersonId($state.params.idNumber, idType)) {
        return;
      }
      
      AppointmentService.SearchWithSubscriptions(
        { id: $scope.person.id },
        place._id,
        $state.params.searchFrom,
      ).then((response) => {
        localStorage.remove('notFoundMessage');
  
        if (response.data.length) {
          $state.go(SAFE_STATES.receptionAppointmentResults, { fields: { id: $state.params.idNumber }, placeId: place._id, organizationId: place.organizationId });
        } else {
          IdentificationService.Identify(
            $scope.person.id,
            $scope.person.gender,
            place.organizationId,
            CalledFromEnum.Reception,
          )
            .then((response) => {
              if (get(response, 'client', false)) {
                $scope.person = {
                  ...$scope.person,
                  firstName: get(response, 'firstName', '') || '',
                  lastName: get(response, 'lastName', '') || '',
                  companyName: get(response, 'companyName', '') || '',
                  idNumber: get(response, 'idNumber', '') || '',
                  gender: get(response, 'gender', '') || '',
                  idType: get(response, 'idType', '') || '',
                };
              } else {
                $scope.person.idNumber = $state.params.idNumber;
              }
  
              if (!$scope.person.priority.category) {
                delete $scope.person.priority;
              }
  
              localStorage.set('identificationData', $scope.person);
              $state.go(SAFE_STATES.receptionStep, { n: 0, placeId: place._id, organizationId: place.organizationId });
            })
            .catch((error) => {
              console.log(error);
              // Show notification error??
            });
        }
      }).catch(err => {
        if (err.data === 'not-authorized') {
          NotificationService.Error($translate.instant('do_not_have_permission_please_check'));
        }
      });
    })
    .catch((error) => {
      if(error && error.status === 404) {
        NotificationService.Error($translate.instant('didnt_found_my_place'));
      }
    });
  }

  $scope.pauseUserCallingAutomatically = () => {
    const callingAutomatically = {
      status: CallingAutomaticallyStatus.Paused,
      reason: CallingAutomaticallyReason.NotValidData,
      serviceId: '',
      serviceType: '',
      userId,
    };

    UserService.UpdateCallingAutomaticallyStatus(userId, callingAutomatically);

    $scope.queryOrganizationAndPlace();
  };

  $scope.validatePersonId = (idNumber, idType) => {
    const identifications = get(
      GlobalsService.CurrentPlace,
      'requirements.identifications',
      [],
    );
    const identification = identifications.find(id => id.key === idType || id.key === idType.toLowerCase());
    const validPersonId = idNumber && validatePersonId(idNumber, idType, $window, identification);
    if (!validPersonId) {
      let i = get(identification, 'name', '');
      let text = $translate.instant('invalid_person_{id}').replace('{id}', i);
      const toasterOptions = { timeOut: 10000 };
      NotificationService.Warning(text, toasterOptions);
    }
    return validPersonId;
  }

};

module.exports = module.controller('ReceptionExternalSearchController', ReceptionExternalSearchController);
